// extracted by mini-css-extract-plugin
module.exports = {"container":"video_container__EICjT","video":"video_video__3L1yp","close_button":"video_close_button__3bt9t"};